import type { Report, Tone } from "@brutally/shared";

export type Plan = "free" | "pro";

export interface SavedRun {
  date: string;
  score: number;
  label: string;
  note: string;
}

export interface SavedSite {
  id: string;
  url: string;
  name: string;
  tone: Tone;
  runs: SavedRun[];
  lenses: Record<string, number>;
  questsDone: number;
  questsTotal: number;
  lastReport?: Report;
}

export interface CoinsState {
  left: number;
  max: number;
  earned: { share?: boolean; firstSave?: boolean; replayAfterFixes?: boolean };
}

export interface Persisted {
  version: 1;
  plan: Plan;
  sites: SavedSite[];
  coins: CoinsState;
}

export const PLAN_LIMITS: Record<Plan, { siteSlots: number; unlimited: boolean; deepHistory: boolean }> = {
  free: { siteSlots: 1, unlimited: false, deepHistory: false },
  pro: { siteSlots: 8, unlimited: true, deepHistory: true }
};

export function siteStats(site: SavedSite) {
  const runs = site.runs;
  if (!runs.length) return { current: 0, first: 0, prev: 0, delta: 0, total: 0, plays: 0 };
  const current = runs[runs.length - 1].score;
  const first = runs[0].score;
  const prev = runs.length > 1 ? runs[runs.length - 2].score : first;
  return { current, first, prev, delta: current - prev, total: current - first, plays: runs.length };
}
